export { default } from './price.component';
